import styled from '@emotion/styled';
import Calendar from 'react-calendar';

const StyledCalendar = styled(Calendar)`
  abbr[title] {
    text-decoration: none !important;
  }

  .react-calendar__tile {
    font-size: 12px;
    text-align: center;
    font-weight: 500;
    line-height: 150%;
    background: none;
    height: 32px;
    max-width: 32px !important;
    margin: 6.8px !important;
    border: none;
  }

  &.react-calendar__tile .react-calendar__month-view__days__day .disabledClass {
    color: var(--color-text-secondary);
  }

  .react-calendar__navigation {
    display: flex;
  }

  .react-calendar__month-view__weekNumbers .react-calendar__tile {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.75em;
    padding: calc(0.75em / 0.75) calc(0.5em / 0.75);
  }

  .react-calendar__year-view .react-calendar__tile,
  .react-calendar__decade-view .react-calendar__tile,
  .react-calendar__century-view .react-calendar__tile {
    padding: 2em 0.5em;
  }

  .react-calendar__tile:enabled:hover,
  .react-calendar__tile:enabled:focus {
    background-color: var(--color-divider);
    border-radius: 50%;
  }

  &.react-calendar
    .react-calendar__viewContainer
    .react-calendar__month-view
    .react-calendar__month-view__days {
    .react-calendar__tile {
      color: var(--color-text-primary);
    }
    .react-calendar__tile:hover {
      color: var(--color-text-primary);
    }
    .disabledClass {
      color: var(--color-text-secondary);
      cursor: auto;
      pointer-events: none !important;
    }
    .disabledClass:hover {
      background-color: transparent !important;
      cursor: not-allowed !important;
    }
  }

  &.react-calendar {
    max-width: 100%;
    font-family: AvertaStd, -apple-system, BlinkMacSystemFont, sans-serif;
    line-height: 1.125em;
    position: fixed;
    top: 112px;
    width: 320px;
    right: calc((100vw - 1136px) / 2);
    z-index: 2;
  }

  &.react-calendar,
  .react-calendar *,
  .react-calendar *:before,
  .react-calendar *:after {
    box-sizing: border-box;
  }

  .react-calendar__navigation button {
    min-width: 44px;
    background: none;
    border: none;
  }

  &.react-calendar button {
    margin: 0;
    border: 0;
    outline: none;
  }

  &.react-calendar .react-calendar__navigation button {
    min-width: 44px;
    background: none;
    border: none;
    color: var(--color-text-primary);
  }

  &.react-calendar__navigation__label button:disabled,
  button[disabled] {
    color: var(--color-text-primary);
    font-weight: bold;
    font-size: 20px;
  }

  &.react-calendar button:enabled:hover {
    cursor: pointer;
  }

  &.react-calendar__navigation {
    height: 44px;
    margin-bottom: 1em;
    border: none;
  }

  &.react-calendar__navigation__label {
    font-weight: bold;
    font-size: 20px;
    line-height: 150%;
  }

  &.react-calendar__navigation__arrow {
    color: var(--color-text-primary);
  }

  .react-calendar__month-view__weekdays {
    text-align: center;
    text-transform: uppercase;
    font-weight: 600;
    color: var(--color-i-black);
    font-size: 14px;
    line-height: 150%;
  }

  .react-calendar__month-view__weekdays__weekday {
    padding: 0.5em;
    color: var(--color-text-primary);
  }

  .react-calendar__month-view__weekNumbers {
    font-weight: bold;
  }

  .react-calendar__month-view__days__day--neighboringMonth {
    color: var(--color-i-gray-1);
    color: var(--color-text-secondary);
    pointer-events: none;
    cursor: no-drop !important;
    opacity: 0.5;
  }

  .react-calendar__tile--hasActive {
    background: var(--color-i-blue-2);
  }

  .react-calendar__tile--hasActive:enabled:hover,
  .react-calendar__tile--hasActive:enabled:focus {
    background: var(--color-i-blue-1);
  }

  .react-calendar__tile--active {
    background: var(--color-i-green) !important;
    color: white !important;
    border-radius: 50%;
    margin: auto !important;
    font-weight: 600;
  }

  .react-calendar__tile.react-calendar__tile--now.react-calendar__tile--active {
    color: white !important;
  }

  .react-calendar__tile--active:enabled:hover,
  .react-calendar__tile--active:enabled:focus {
    background: var(--color-i-blue-3);
  }

  .react-calendar--selectRange .react-calendar__tile--hover {
    background-color: var(--color-divider);
  }

  .react-calendar__tile.react-calendar__tile--now {
    color: var(--color-i-green) !important;
    font-weight: 600;
  }
`;

export default StyledCalendar;
